import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // Correct named import for v4+ typically, checking run output for version first might be good but standard is named or default.
// If jwt-decode defaults to default export in older versions, we might need adjustments. 
// Standard for modern: import { jwtDecode } from "jwt-decode";

export const useAdminAuth = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const checkAdmin = () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setIsAdmin(false);
          setIsLoaded(true);
          return;
        }

        const decoded = jwtDecode(token);
        
        // Check for 'is_admin' claim
        if (decoded?.is_admin === true) {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
      } catch (error) {
        console.error("Failed to decode token for admin check", error);
        setIsAdmin(false);
      } finally {
        setIsLoaded(true);
      }
    };

    checkAdmin();
  }, []);

  return { isAdmin, isLoaded };
};
